import { TradeHistoryResponseOperationTypeEnum } from '../../generated';
import { TradeHistory } from './type';

export const getIsHiddenEvent = (history: TradeHistory) => {
  if (
    [
      // keeper failed liquidating, tp or sl
      TradeHistoryResponseOperationTypeEnum.ExecuteCloseRejected,
      // keeper failed executing a limit order, for 'real' failure, see LimitOrderRefund
      TradeHistoryResponseOperationTypeEnum.ExecuteLimitOrderRejected,
      // OpenMarketTrade serve same purpose
      TradeHistoryResponseOperationTypeEnum.ExecuteLimitOrderSuccessful,
    ].includes(history.type)
  ) {
    return true;
  }

  // A single update call writes both TP and SL (updateTradeTpAndSl /
  // updateOrderTpAndSl), so the BE emits an event for the side that didn't
  // actually change — e.g. SL 0 -> 0 when the user only edited TP. Hide these
  // no-op updates so they don't clutter history.
  switch (history.type) {
    case TradeHistoryResponseOperationTypeEnum.UpdateTradeSl:
    case TradeHistoryResponseOperationTypeEnum.UpdateOrderSl:
      return history.detail.oldSl.eq(history.detail.sl);
    case TradeHistoryResponseOperationTypeEnum.UpdateTradeTp:
    case TradeHistoryResponseOperationTypeEnum.UpdateOrderTp:
      return history.detail.oldTp.eq(history.detail.tp);
    default:
      return false;
  }
};

/**
 * Events on unfilled limit orders (cancel / update SL / update TP) have no
 * entryPrice and the BE doesn't carry the order's trigger price on these
 * records, so there's no reference price to compute leverage from.
 *
 * Position-side updates (UpdateMargin, UpdateTradeSl, UpdateTradeTp) already
 * carry the position's entryPrice and don't fall in here.
 */
export const getHasInvalidLeverage = (history: TradeHistory) => {
  return [
    TradeHistoryResponseOperationTypeEnum.CancelLimitOrder,
    TradeHistoryResponseOperationTypeEnum.UpdateOrderSl,
    TradeHistoryResponseOperationTypeEnum.UpdateOrderTp,
  ].includes(history.type);
};
